(function($) {


	var wow = new WOW(
      {
  		mobile: false
    }
    )
    wow.init();

	//universal vars
	var 	siteHeader = $('header.site-header'),
			backgroundwrapper = $('.background-wrapper'),
			scrollDistance = $(window).scrollTop();

	$(document).ready(function(){

		$('.testimonials-slider').slick({
		  dots: true,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 3,
		  arrows: true,
		  //fade: true,
		  centerMode: false,
		  centerPadding: '100px',
		  appendArrows: $('#test-home-buttons'),
		  appendDots:  $('#test-home-dots'),
		  responsive: [
			{
			  breakpoint: 768,
			  settings: {
			     slidesToShow: 2,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			   centerMode: true,
		  		centerPadding: '30px',
		  		slidesToShow: 1,
		  		dots: false,
			  }
			}
			]
		});

		$('.homepage-slider').slick({
		  dots: true,
		  infinite: true,
		  speed: 1000,
		  slidesToShow: 1,
		  arrows: true,
		  adaptiveHeight: false,
		  autoplay: true,
		  fade: true,
		  //appendArrows: $('.homepage-slide-arrows'),
		  //appendDots:  $('.homepage-slide-dots'),
		  responsive: [
			{
			  breakpoint: 768,
			  settings: {
			    dots: true,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			   dots: false,
			   adaptiveHeight: true,
			  }
			}
			]
		});

		
		$('.homepage-logos').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 400,
			slidesToShow: 5,
			centerMode: false,
			autoplay: true,
			responsive: [
			{
			  breakpoint: 768,
			  settings: {
			    slidesToShow: 5
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    slidesToShow: 2,
			     centerMode: false,
			  }
			}
			]
		});

		 var windowWidth = $(window).width();

        if(windowWidth > 1170) {
            var centerPadAmount = (windowWidth - 1170) / 2;
        }

        else {
            var centerPadAmount = 20;
        }

        var gallerySlider = function($selector) { 

        var galleryArrows = $($selector).siblings('.gallery-arrows');
            
        $($selector).slick({
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        autoplay:true,
        initialSlide: 0,
        centerMode: true,
        centerPadding: centerPadAmount + 'px',
        appendArrows: galleryArrows,
        prevArrow: '<button type="button" class="cat-prev"></button>',
        nextArrow: '<button type="button" class="cat-next"></button>',
        fade: false,
        responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: true,
                slidesToShow: 1,
              }
            }
            ],
        });
        }

        //gallerySlider('.image-gallery-header-slider');

        var imageGalleryExtra = $('.image-gallery-extra');

        $(imageGalleryExtra).each(function(){
            gallerySlider(this);
        });
      });


	$(window).on('load',function() {

		// Animate loader off screen
	    $("#loader").fadeOut(300);
	});

	
	//scroll functions

	$(window).on('scroll',function() {
		scrollDistance = $(window).scrollTop();
		stickyHeaderClass(scrollDistance,50,siteHeader);
		if(scrollDistance > 100) {
			$('.booking-call-overlay').addClass('scrolled-call');
		}
		else {
			$('.booking-call-overlay').removeClass('scrolled-call');
		}
	});

	//sticky header function
	var stickyHeaderClass = function(scrollDistanceMonitor, classDistance, headerSelector){
		if(scrollDistanceMonitor > classDistance) {
			$(headerSelector).addClass('scrolled');
			// $('.top-title img').fadeOut('slow', function(){
			// 	$('.scroll-title img').fadeIn('slow', function() {
			// 		$('.site-title img').addClass('scaled-title');

			// 	});
			// });	
		}
		else {
			$(headerSelector).removeClass('scrolled');
			// $('.scroll-title img').fadeOut('slow', function(){
			// 	$('.top-title img').fadeIn('slow', function() {
			// 		$('.site-title img').removeClass('scaled-title');
			// 	});
			// });
		}
	};


//animate all anchor links

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth',
            block: "nearest", 
        });
    });
});


$('button.hamburger').on('click',function(event){
	$(this).toggleClass('is-active');
});

//open and close search menu
$('.mini-cart-toggle').on("click", function (event) {
    event.preventDefault();
    $('.mini-cart').toggleClass('opened');
    $('body').toggleClass('cart-opened');
    event.stopPropagation();
});

$(document).on('click' , function(e){
    var $menu = $('.nav-primary'),
        $targetBody = $('body'),
        $menuButton = $('.menu-toggle'),
        $miniCart = $('.mini-cart')
        // $searchOverlay = $(".search-overlay"),
        // $menuSearchButton = $('.menu-search a');

    // When the search menu is open this will close it on click outside form
    if (!$miniCart.is(e.target) // if the target of the click isn't the container...
    && $miniCart.has(e.target).length === 0 && !$miniCart.is(e.target) && $targetBody.hasClass('cart-opened')) 
    // ... nor a descendant of the container

    {       event.preventDefault();
            $($targetBody).removeClass('cart-opened');
            $('.mini-cart').toggleClass('opened');
            event.stopPropagation();
    }
});

jQuery(document).ready(function($){
    $('body').on( 'added_to_cart', function(){
        event.preventDefault();
	    $('.mini-cart').toggleClass('opened');
	    $('body').toggleClass('cart-opened');
	    event.stopPropagation();
    });

});
	
})( jQuery );